module.exports = __webpack_public_path__ + "img/johnoliver4.a0f1cc7f.jpg";